export const VIDEO_SIZE = {
  width: 1280,
  height: 720,
};

export const VIDEO_MOBILE_SIZE = {
  width: 640,
  height: 480,
};

export const SHARE_VIDEO_SIZE = {
  width: 1920,
  height: 1080,
};

export const SHARE_VIDEO_MOBILE_SIZE = {
  width: 1280,
  height: 720,
};

export const VIDEO_BITRATE = [250000, 500000, 1600000];

export const SHARE_VIDEO_BITRATE = [800000, 1500000];

export const EVENT = Object.freeze({
  ADD_PEER: 'addPeer',
  CHAT: 'chat',
  CLOSE_THIS_CONNECTION: 'closeThisConnection',
  CONNECTION_TIMED_OUT: 'connectionTimedOut',
  CONSUMER_CLOSED: 'consumerClosed',
  CONSUMER_COUNT: 'consumerCount',
  CUSTOM: 'custom',
  DOMINANT_SPEAKER: 'dominantSpeaker',
  DUPLICATE_PEER: 'duplicatePeer',
  FORCE_HIDE_VIDEO: 'forceHideVideo',
  FORCE_MUTE: 'forceMute',
  FORCE_STOP_SCREEN_SHARE: 'forceStopScreenShare',
  KICKED: 'kicked',
  NEW_PRODUCER: 'newProducer',
  PEER_HIDE_VIDEO: 'peerHideVideo',
  PEER_JOINED: 'peerJoined',
  PEER_MUTED: 'peerMuted',
  PEER_NETWORK_STATUS: 'peerNetworkStatus',
  PEER_PRIORITIES: 'peerPriorities',
  PEER_REMOVED: 'peerRemoved',
  PEER_STATE: 'peerState',
  PRODUCER_CLOSED: 'producerClosed',
  PRODUCER_MAX_LAYERS: 'producerMaxLayers',
  PRODUCER_PAUSED: 'producerPaused',
  PRODUCER_RESUMED: 'producerResumed',
  RAISE_HAND: 'raiseHand',
  REQUEST_ACCEPTED: 'requestAccepted',
  REQUEST_DENIED: 'requestDenied',
  REQUEST_JOIN: 'requestJoin',
  RECORDING_STARTED: 'recordingStarted',
  RECORDING_STOPPED: 'recordingStopped',
  ROOM_CLOSED: 'roomClosed',
  ROOM_LOCK_UPDATED: 'roomLockUpdated',
  SHARE_PRODUCER: 'shareProducer',
  UPDATED_MEMBERS_LIST: 'updatedMembersList',
  USERS_ENTERED_LOBBY: 'usersEnteredLobby',
  USERS_IN_QUEUE: 'usersInQueue',
  USERS_LEFT_LOBBY: 'usersLeftLobby',
});

export const CONTROL = Object.freeze({
  PEER_MUTE: 'peerMute',
  PEER_HIDE_VIDEO: 'peerHideVideo',
  PEER_RAISE_HAND: 'peerRaiseHand',
  PEER_LEAVE: 'peerLeave',
  PEER_KICK: 'peerKick',
  PEER_MUTE_ALL: 'peerMuteAll',
  PEER_LOWER_HAND_ALL: 'peerLowerHandAll',
  ROOM_CLOSE: 'roomClose',
});
